if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const mainVariantId = formData.get('id');
        const productInfo = this.closest('product-info');
        const addonController =
          productInfo?.querySelector('sunpura-pdp-configurator') ||
          productInfo?.querySelector('s2400-configurator');
        const addonState = addonController?.getState
          ? addonController.getState()
          : { items: [], count: 0, totalCents: 0 };
        const hasSunpuraAddons = Array.isArray(addonState.items) && addonState.items.length > 0;

        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
        }

        if (hasSunpuraAddons) {
          const mainProperties = {};
          for (const [key, value] of formData.entries()) {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match && value !== '') mainProperties[match[1]] = value;
          }

          const mainItem = {
            id: Number(mainVariantId),
            quantity: Number(formData.get('quantity') || 1)
          };
          if (Object.keys(mainProperties).length) mainItem.properties = mainProperties;
          const sellingPlan = formData.get('selling_plan');
          if (sellingPlan) mainItem.selling_plan = Number(sellingPlan);

          const addonItems = addonState.items.map((item) => ({
            id: Number(item.id),
            quantity: Number(item.quantity || 1),
            properties: {
              ...(item.properties || {}),
              _sp_role: 'paid_addon',
              _sp_source: item.properties?._sp_source || 'sunpura_pdp'
            }
          }));

          const payload = { items: [mainItem, ...addonItems] };
          if (this.cart) {
            payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
            payload.sections_url = window.location.pathname;
          }
          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify(payload);
        } else {
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
          }
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: mainVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: mainVariantId,
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('wb-quick-view');
            const wbModel = this.closest('wb-modal');
            if(wbModel){
              wbModel?.close();
            }
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
            if (addonController) this.handleErrorMessage(addonController?.config?.cart_error || window.cartStrings?.error);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}